module.exports = __webpack_public_path__ + "Flag-762.857faa16fd77deeac5b6541aeaab600b.svg";